
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRadarTargetTrackedIec as ObiRadarTargetTrackedIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-radar-target-tracked-iec.js';
 
 
 

 
 export const ObiRadarTargetTrackedIec = createComponent({
   react: React,
   tagName: 'obi-radar-target-tracked-iec',
   elementClass: ObiRadarTargetTrackedIecElement,
   events: {
     
   }
  });
 
 